// src/utils/string-utils.ts
/**
 * Chuyển đổi chuỗi thành dạng title case
 * @example toTitleCase("hello world") => "Hello World"
 */
export const toTitleCase = (str: string): string => {
    if (!str) return '';
    return str.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
};

/**
 * Rút gọn chuỗi nếu vượt quá độ dài tối đa
 * @param text Chuỗi cần rút gọn
 * @param maxLength Độ dài tối đa (mặc định: 100)
 * @param suffix Ký tự đuôi khi chuỗi bị cắt (mặc định: "...")
 */
export const truncateText = (
    text: string,
    maxLength: number = 100,
    suffix: string = '...'
): string => {
    if (!text) return '';
    if (text.length <= maxLength) return text;

    return text.substring(0, maxLength).trim() + suffix;
};

/**
 * Đọc thời gian tương đối (ví dụ: "2 giờ trước", "5 ngày trước")
 * @param dateString Chuỗi ngày hoặc đối tượng Date
 */
export const timeAgo = (dateString: string | Date): string => {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1
    };

    const names = {
        year: ['năm', 'năm'],
        month: ['tháng', 'tháng'],
        week: ['tuần', 'tuần'],
        day: ['ngày', 'ngày'],
        hour: ['giờ', 'giờ'],
        minute: ['phút', 'phút'],
        second: ['giây', 'giây']
    };

    for (const [interval, secondsInInterval] of Object.entries(intervals)) {
        const count = Math.floor(seconds / secondsInInterval);
        if (count > 0) {
            const name = names[interval][count === 1 ? 0 : 1];
            return `${count} ${name} trước`;
        }
    }

    return 'Vừa xong';
};

/**
 * Tạo chuỗi slug từ text
 * @example generateSlug("Xin chào Việt Nam") => "xin-chao-viet-nam"
 */
export const generateSlug = (text: string): string => {
    if (!text) return '';

    // Chuyển đổi các ký tự đặc biệt tiếng Việt
    const from = 'àáảãạăằắẳẵặâầấẩẫậđèéẻẽẹêềếểễệìíỉĩịòóỏõọôồốổỗộơờớởỡợùúủũụưừứửữựỳýỷỹỵ';
    const to = 'aaaaaaaaaaaaaaaaaeeeeeeeeeeeiiiiiooooooooooooooooouuuuuuuuuuuyyyyy';

    let result = text.toLowerCase();

    // Thay thế các ký tự tiếng Việt
    for (let i = 0; i < from.length; i++) {
        result = result.replace(new RegExp(from[i], 'g'), to[i]);
    }

    return result
        .replace(/[^\w\s-]/g, '') // Xóa ký tự đặc biệt
        .replace(/\s+/g, '-') // Thay khoảng trắng bằng dấu gạch ngang
        .replace(/-+/g, '-') // Loại bỏ dấu gạch ngang liên tiếp
        .trim(); // Xóa khoảng trắng ở đầu và cuối
};

/**
 * Tạo chuỗi ID ngẫu nhiên
 * @param length Độ dài của ID (mặc định: 10)
 */
export const generateRandomId = (length: number = 10): string => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
};

export const toCamelCase = (str: string): string => {
    if(!str) return '';
    return str
        .toLowerCase()
        .replace(/[_-\s]+(.)?/g, (_, char) => char ? char.toUpperCase() : '');
};

export default {
    toTitleCase,
    truncateText,
    timeAgo,
    generateSlug,
    generateRandomId,
    toCamelCase
};